// extracted by mini-css-extract-plugin
module.exports = {"section":"List_section__2jnFl","wrap":"List_wrap__2JsxA"};